!((document, Drupal, $) => {
  'use strict';

  /**
   * Dialogs JS
   */
  $(window).on('dialog:aftercreate', (event, dialog, element) => {

    const uiDialog = document.querySelector('.ui-dialog');
    if (uiDialog) {
      const closeButton = uiDialog.querySelector('.ui-dialog-titlebar-close');
      closeButton.innerHTML = '';

      const closeIcon = document.createElement('span');
      closeIcon.classList.add('uk-icon--close');
      closeIcon.setAttributeNS('', 'uk-icon', 'icon: close');
      closeButton.appendChild((closeIcon));
    }

    /**
     * Header Login popup JS
     */
    const createdDialog = dialog;
    const loginPopup = element[0];
    const loginForm = document.querySelector('#modal_form_wrapperuser_login_form');

    if (loginPopup && loginForm) {
      const registerLink = loginForm.querySelector('.register-link');
      if (registerLink !== null) {
        registerLink.addEventListener('click', () => {
          createdDialog.close();
          const registerBtn = document.querySelector('.register-popup-form');
          if (registerBtn) {
            registerBtn.click();
          }
        });
      }
    }
  });

  /**
   * Header Navbar menu JS
   */
  Drupal.behaviors.headerNavbar = {
    attach: (context) => {
      once('headerAccountMenu', '.oxadi-account-menu', context).forEach(oxadiAccountMenu => {
        const $html = $('html');
        if (!$html.hasClass('authenticated')) {
          $(oxadiAccountMenu).find('a').removeAttr('href').addClass('disabled');
        }
      });
    },
  };

})(document, Drupal, jQuery);
